import arrowCircle from './arrow-circle.svg?raw';
import arrow from './arrow.svg?raw';
import check from './check.svg?raw';

export default { check, arrow, arrowCircle };
